import { Component, Inject, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AppSettings } from 'src/app/core/common/app-settings';
import { StateConstant } from 'src/app/core/common/state-constant';
import { OperacionEnum } from 'src/app/core/enums/operacion.enum';
import { DesaparecidoGamService } from 'src/app/core/services/gam/desaparecido-gam.service';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { DesaparecidoFotografiaDto } from 'src/app/shared/models/gam/desaparecido-fotografia-dto.model';

@Component({
  selector: 'vex-desaparecido-image-form',
  templateUrl: './desaparecido-image-form.component.html',
  styleUrls: ['./desaparecido-image-form.component.scss']
})
export class DesaparecidoImageFormComponent implements OnInit {
  appSettings = AppSettings;
  stateConstant = StateConstant;

  desaparecidoGamService = inject(DesaparecidoGamService);
  maxDate = new Date();
  form: FormGroup;
  public operation: OperacionEnum;
  dto: DesaparecidoFotografiaDto = new DesaparecidoFotografiaDto();

  id: number;

  file: File;
  base64: string;
  fileName: string;
  isComprobante: boolean;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private fb: FormBuilder) {
    this.operation = data.operation;
    this.id = data.entity;
    this.isComprobante = data.isComprobante;
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      image: ['', Validators.required]
    });
  }

  save() {
    this.dto.image = this.base64;
    if (this.isComprobante) {
      this.desaparecidoGamService.updateFotografia(this.id, this.dto).subscribe(
        data => {
          if (data.status) {
            this.toastr.success("Actualizado correctamente.");
            this.dialogRef.close(true);
          } else {
            this.toastr.warning(data.message);
          }
        },
        error => {
          this.toastr.error('Ocurrió un error: ' + error.message);
        }
      );
    }
  }

  convertFile(file: File) {
    var myReader: FileReader = new FileReader();
    myReader.onloadend = (e) => {
      this.base64 = myReader.result.toString();
    }
    myReader.readAsDataURL(file);
  }

  fileChangeListener($event): void {
    this.file = $event.target.files[0];
    this.fileName = this.file.name;
    if (this.file.type === 'image/png' || this.file.type === 'image/jpeg' || this.file.type === 'image/jpg')
      this.convertFile(this.file);
    else {
      this.file = null
      this.form.controls['image'].setValue(null);
      this.toastr.warning('Solo se permite archivos PNG, JPG y JPEG.');
    }
  }
}
